import React, {useCallback, useEffect, useRef, useState} from "react";
import Button from "@/components/inputs/button";
import SimpleText from "@/components/texts/simpleText";
import ButtonLink from "@/components/inputs/buttonLink";
import {useDispatch, useSelector} from "react-redux";
import {
    GET_ALL_STATE,
    GET_USER_EMAIL,
    SET_LOADING,
    SET_MODAL,
    SET_RECAPTCHA,
    SET_USER_EMAIL,
    SET_USER_STEP,
    SET_USER_TAB
} from "@/store/slices/appSlice";
import InputWithValidation from "@/components/inputs/inputWithValidation";
import {SET_USER, SET_USER_ALERT} from "@/store/slices/userSlice";
import {useCookies} from "react-cookie";
import themes from "@/styles/themes";

import Events from "@/utils/Events";
import Lead from "@/utils/Lead";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import Apm from "@/utils/Apm";
import { createUser } from "@/api/assine";
import { validateRecaptcha } from "@/api/recaptcha";
import IRegisterResponse, { IUserCookie } from "@/types/IRegisterResponse";
import Nullable from "@/types/utils/Nullable";
import { isDataNascimento, isEmail, isName, isTelephoneNumber } from "@/utils/validation";
import { isProduction } from "@/utils/environment";
import { safeDecode } from "@/utils/cookies";
import useRecaptcha from "@/hooks/useRecaptcha";
import styled from "styled-components";
import { set } from "react-hook-form";

const EmailCard = styled.div`
    background: #e4e4e8;
    border-radius: 8px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0 12px 0
`

const EmailInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

const EmailIcon = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #d9d9d9;
    display: flex;
    align-items: center;
    justify-content: center;
`

const EmailText = styled.span`;
    color: #56565f;
`

export default function Cadastrar() {

    const events = new Events();
    const dispatch = useDispatch();
    const setCookie = useCookies()[1];
    const states = useSelector(GET_ALL_STATE)
    const offer_type = useSelector(GET_OFFER_TYPE)
    const [nome, setNome] = useState('')
    const [email, setEmail] = useState(useSelector(GET_USER_EMAIL))
    const [senha, setSenha] = useState('')
    const [confirmar_senha, setConfirmarSenha] = useState('')
    const [telefone, setTelefone] = useState('')
    const [nomeErrorMessage, setNomeErrorMessage] = useState<Nullable<string>>(null)
    const [emailErrorMessage, setEmailErrorMessage] = useState<Nullable<string>>(null)
    const [senhaErrorMessage, setSenhaErrorMessage] = useState<Nullable<string>>(null)
    const [confirmar_senhaErrorMessage, setConfirmarSenhaErrorMessage] = useState<Nullable<string>>(null)
    const [telefoneErrorMessage, setTelefoneErrorMessage] = useState<Nullable<string>>(null)
    const [dt_nascimento, setDtNascimento] = useState('')
    const [dt_nascimentoErrorMessage, setDtNascimentoErrorMessage] = useState<Nullable<string>>(null)

    const [all_states, setStates] = useState(states)
    const recaptcha = useRecaptcha()

    useEffect(() => {
        setStates(states)
    }, [states]);

    useEffect(() => {
        setTimeout(() => events.trigger("identificacao_cadastro_visualizado", { offer_type }), 3000);
    }, [offer_type]);

    function setTab(idx: number) {
        dispatch(SET_USER_TAB(idx))
    }

async function submitData(event: any) {
    event.preventDefault()
    recaptcha.reset()
    let erroNoFormulario: boolean = false

    if(!isEmail(email)){
        erroNoFormulario = true
        events.trigger('identificacao_cadastro_erro_email', { offer_type })
        setEmailErrorMessage('Email Inválido')
    }

    if(!isName(nome)){
        erroNoFormulario = true
        events.trigger('identificacao_cadastro_erro_nome', { offer_type })
        setNomeErrorMessage('Nome não está completo ou o formato é inválido')
    }

    // if(!isDataNascimento(dt_nascimento, setDtNascimentoErrorMessage)){
    //     erroNoFormulario = true
    //     events.trigger('identificacao_cadastro_erro_dt_nascimento', { offer_type })
    // }

    if(!isTelephoneNumber(telefone)){
        erroNoFormulario = true
        events.trigger('identificacao_cadastro_erro_telefone', { offer_type })
        setTelefoneErrorMessage('Celular inválido')
    }

    if(senha.length < 6){
        erroNoFormulario = true
        events.trigger('identificacao_cadastro_erro_senha', { offer_type })
        setSenhaErrorMessage('As senhas devem ter no mínimo 6 caracteres')
    }

    if(senha !== confirmar_senha){
        erroNoFormulario = true
        events.trigger('identificacao_cadastro_erro_confirme_senha', { offer_type })
        setConfirmarSenhaErrorMessage('As senhas devem ser iguais')
    }

    if(erroNoFormulario){
        return
    }

    setEmailErrorMessage('')
    setNomeErrorMessage('')
    setDtNascimentoErrorMessage('')
    setTelefoneErrorMessage('')
    setSenhaErrorMessage('')
    setConfirmarSenhaErrorMessage('')

    try {
        recaptcha.reset()
        if (recaptcha.isLoading) {
            throw new Error('reCAPTCHA ainda está carregando, tente novamente')
        }

        const registrationToken = await recaptcha.validate('REGISTRATION')
        dispatch(SET_LOADING(true))

        const aux = nome.trim().replace(/\s+/g, ' ')
        const [firstName, ...rest] = aux.split(' ')
        const lastName = rest.join(' ')
        const userData = {
            email: email.trim(),
            password: senha,
            re_password: confirmar_senha,
            dt_nascimento: dt_nascimento.replace(/\//g, ''),
            telefone,
            nome: firstName,
            sobrenome: lastName,
            recaptcha: {
                token: registrationToken,
                action: 'REGISTRATION',
            },
        }

        const data: IRegisterResponse = await createUser(userData)
        Lead.save(all_states.lead.value, dispatch)
        if(data){
            events.trigger("identificacao_cadastro_sucesso", { offer_type })
        }
        const { cookies } = data
        let user_data: any = {
            id: data.id,
            email: data.email,
        }

        if (cookies) {
            try {
                Object.values(cookies).forEach((value: IUserCookie) => {
                    value.value = safeDecode(value.value)
                    setCookie(value.name, value.value, {
                        domain: value.domain,
                        path: value.path,
                        secure: true,
                        expires: value.expire
                            ? new Date(parseInt(String(value.expire).padEnd(13, '0')))
                            : new Date(),
                    })

                    if (value.name === 'OESP_INFO') {
                        user_data = {
                            ...user_data,
                            ...JSON.parse(value.value),
                        }
                    }
                })
            } catch (err) {
                Apm.captureError(`CADASTRO_SET_COOKIE: ${err}`)
            }
        }

        events.trigger('identificacao_cadastro_sucesso', { show: true })

        dispatch(
            SET_USER({
                email: user_data.email,
                id_usuario: user_data.id,
            }),
        )

        // 🔥 AQUI ESTÁ O AJUSTE 🔥
        try {
            const completeToken = await recaptcha.validate('SIGN_UP_COMPLETE')

            await validateRecaptcha(completeToken, 'SIGN_UP_COMPLETE', {
                accountId: user_data.id,
                responsavel: {
                    email: user_data.email,
                    celular: telefone,
                    nome: aux,
                },
            })
        } catch (err) {
            Apm.captureError(
                new Error(`Erro reCAPTCHA SIGN_UP_COMPLETE: ${err}`),
            )
        }

        dispatch(SET_USER_STEP(2))
    } catch (error: any) {
        Apm.captureError(error)
        if (error?.response?.status === 409) {
                dispatch(SET_MODAL({type:"email-ja-cadastrado",show:true, email: email.trim()}))
                recaptcha.reset()
        } 
    } finally {
        dispatch(SET_LOADING(false))
    }
}

    return <div onClick={()=>dispatch(SET_USER_ALERT({show: false}))}>
        <SimpleText color={themes.estadaoBlue} style={{margin: '6px 0px'}}>
            Já possui uma conta?{' '}
            <ButtonLink
                color={`${themes.estadao} !important`}
                style={{textDecoration: 'underline', fontSize:'13px', fontWeight:'bold'}}
                onClick={() => {
                    events.trigger("identificacao_faca_o_login", { offer_type })
                    setTab(0)
                }}
            >
                Faça o login.
            </ButtonLink>
        </SimpleText>
        <form onSubmit={submitData}>

            {email ? (
                <div style={{marginBottom: '16px'}}>
                    <EmailCard>
                        <EmailInfo>
                            <EmailIcon>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M16 3C8.82 3 3 8.82 3 16c0 2.989 1.009 5.742 2.704 7.938.522-2.189 1.506-3.97 2.88-5.31a9.41 9.41 0 0 1 2.615-1.805 6.773 6.773 0 1 1 9.6 0 9.41 9.41 0 0 1 2.618 1.804c1.373 1.342 2.357 3.122 2.88 5.31A12.943 12.943 0 0 0 29 16c0-7.18-5.82-13-13-13zm10.2 25.328A15.967 15.967 0 0 0 32 16c0-8.837-7.163-16-16-16S0 7.163 0 16a15.967 15.967 0 0 0 5.853 12.372A15.934 15.934 0 0 0 16 32a15.934 15.934 0 0 0 10.2-3.672zm-2.529-1.832c-.23-2.703-1.141-4.541-2.35-5.723-1.319-1.288-3.151-1.952-5.306-1.955h-.03c-2.155.003-3.987.668-5.305 1.955-1.21 1.181-2.121 3.02-2.35 5.723A12.942 12.942 0 0 0 16 29c2.87 0 5.521-.93 7.671-2.504zm-7.657-10.678a3.773 3.773 0 1 0-.027 0h.027z" fill="#1E1E21"/>
                                </svg>
                            </EmailIcon>

                            <EmailText>{email}</EmailText>
                        </EmailInfo>
                    </EmailCard>
                    
                    <div style={{width:'100%', display: 'flex', justifyContent: 'end'}}>
                        <ButtonLink
                            color={`${themes.estadao} !important`}
                            style={{textDecoration: 'underline', fontSize:'13px', fontWeight:'bold'}}
                            onClick={() => {
                                events.trigger("identificacao_trocar_email", { offer_type })
                                setTab(0)
                            }}
                        >
                            Trocar E-mail
                        </ButtonLink>
                    </div>

                </div>
                
            ) : (
                <InputWithValidation
                    id={'email'}
                    type={'email'}
                    placeholder={'E-mail'}
                    name={'email'}
                    OnClick={() => {
                        events.trigger("identificacao_cadastro_email", { offer_type })
                        setEmailErrorMessage(null)
                    }}
                    errorMessage={emailErrorMessage}
                    onChange={setEmail}
                    value={email}
                />
            )}

            <div>
                <InputWithValidation
                    id={'name'}
                    type={'text'}
                    placeholder={'Nome completo'}
                    name={'nome'}
                    OnClick={()=> {
                        events.trigger("identificacao_cadastro_nome", { offer_type }),
                        setNomeErrorMessage(null)
                    }}
                    errorMessage={nomeErrorMessage}
                    onChange={setNome}
                    value={nome}
                />
            </div>
            <div>
                <InputWithValidation
                    id={'telefone'}
                    type={'telefone'}
                    placeholder={'Celular'}
                    name={'telefone'}
                    OnClick={()=> {
                        events.trigger("identificacao_cadastro_telefone", { offer_type }),
                        setTelefoneErrorMessage(null)
                    }}
                    errorMessage={telefoneErrorMessage}
                    onChange={setTelefone}
                    value={telefone}
                />
            </div>
        {/* <div>
                <InputWithValidation
                    id={'dt_nascimento'}
                    type={'text'}
                    placeholder={'Data de Nascimento'}
                    name={'dt_nascimento'}
                    OnClick={()=> {
                        events.trigger("identificacao_cadastro_dt_nascimento", { offer_type }),
                        setDtNascimentoErrorMessage(null)
                    }}
                    errorMessage={dt_nascimentoErrorMessage}
                    onChange={setDtNascimento}
                    value={dt_nascimento}
                />
            </div> */}
            <div>
                <InputWithValidation
                    id={'senha'}
                    type={'password'}
                    placeholder={'Senha'}
                    name={'senha'}
                    OnClick={()=> {
                        events.trigger("identificacao_cadastro_senha", { offer_type }),
                        setSenhaErrorMessage(null)
                    }}
                    errorMessage={senhaErrorMessage}
                    onChange={setSenha}
                    value={senha}
                />
            </div>
            <div>
                <SimpleText color={themes.estadaoBlue}>
                    As senhas devem ter no mínimo 6 caracteres
                </SimpleText>
            </div>
            <div>
                <InputWithValidation
                    id={'confirmar_senha'}
                    type={'password'}
                    placeholder={'Confirme a senha'}
                    name={'confirmar_senha'}
                    OnClick={()=> {
                        events.trigger("identificacao_cadastro_confirme_senha", { offer_type }),
                        setConfirmarSenhaErrorMessage(null)
                    }}
                    errorMessage={confirmar_senhaErrorMessage}
                    onChange={setConfirmarSenha}
                    value={confirmar_senha}
                />
            </div>
            <div>
                <Button
                    data-transaction-name="Cadastrar Usuario"
                    onClick={() => {
                        events.trigger("identificacao_cadastro_continuar", { offer_type })
                    }}
                >
                    Continuar
                </Button>
            </div>
        </form>
    </div>
}
